import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface LastSearchesState {
  globalLastSearches: string[];
  storeLastSearches: { [storeId: string]: string[] };
}

const initialState = {
  globalLastSearches: [],
  storeLastSearches: {},
} as LastSearchesState;

export const lastSearchesSlice = createSlice({
  name: "lastSearches",
  initialState,
  reducers: {
    ADD_GLOBAL_SEARCH: (state, action: PayloadAction<string>) => {
      if (state.globalLastSearches?.length === 10) {
        state.globalLastSearches.shift();
      }
      if (!state.globalLastSearches.some((s) => s === action.payload)) {
        state.globalLastSearches?.push(action.payload);
      }
    },
    ADD_STORE_SEARCH: (
      state,
      action: PayloadAction<{
        storeId: string;
        query: string;
      }>
    ) => {
      const { storeId, query } = action.payload;
      const storeSearch = state.storeLastSearches[storeId];
      if (storeSearch) {
        if (storeSearch?.length === 10) {
          state.storeLastSearches[storeId].shift();
        }
        if (!storeSearch.some((s) => s === query)) {
          state.storeLastSearches[storeId]?.push(query);
        }
      } else {
        state.storeLastSearches[storeId] = [query];
      }
    },
  },
});

export const { ADD_GLOBAL_SEARCH, ADD_STORE_SEARCH } = lastSearchesSlice.actions;

export default lastSearchesSlice.reducer;
